// extracted by mini-css-extract-plugin
export var pillWrapper = "_xv-0";
export var showOverflow = "_xv-1";